import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function NotFound() {
  const { t } = useTranslation();

  return (
    <div className="bg-white min-h-screen px-4 py-24 sm:py-32 lg:px-8">
      <div className="mx-auto max-w-max lg:max-w-2xl text-center">
        {/* Big amusing 404 number */}
        <p className="text-8xl font-extrabold text-amber-600 sm:text-9xl">404</p>
        
        <h1 className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
          {t("notFound.title")}
        </h1>
        <p className="mt-4 text-base leading-7 text-gray-600">
          {t("notFound.description")}
        </p>
        
        {/* Helpful links */}
        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/"
            className="w-full sm:w-auto rounded-md bg-orange-600 px-6 py-3 text-sm font-semibold text-white shadow-sm hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2"
          >
            {t("notFound.backHome")}
          </Link>
          <Link
            to="/products-filters"
            className="w-full sm:w-auto rounded-md border border-gray-300 bg-white px-6 py-3 text-sm font-semibold text-gray-900 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2"
          >
            {t("notFound.browseProducts")}
          </Link>
          <Link
            to="/shopping-cart"
            className="w-full sm:w-auto rounded-md border border-gray-300 bg-white px-6 py-3 text-sm font-semibold text-gray-900 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2"
          >
            {t("notFound.viewCart")}
          </Link>
        </div>
        
        {/* Optional: a helpful suggestion */}
        <p className="mt-10 text-sm text-gray-500">
          {t("notFound.contact")}{" "}
          <a href="mailto:hola@mexabeer.com" className="font-medium text-amber-600 hover:text-amber-500">
            hola@mexabeer.com
          </a>
        </p>
      </div>
    </div>
  );
}